import { FC, ReactElement, useMemo } from 'react';
import { PreparationOrderSettingsInput } from '../PreparationOrderSettingsInput/PreparationOrderSettingsInput';
import { PreparationOrderSettingsRadios } from '../PreparationOrderSettingsRadios/PreparationOrderSettingsRadios';
import { preparationTimeUnitOptions } from '../../constants/preparationProfiles';
import Text, { TEXT } from '~/view/components/Text/Text';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export const PreparationProfileDeliverySettings: FC = (): ReactElement | null => {
  const timeUnitOptions = useMemo((): IPickerOption[] => preparationTimeUnitOptions(), []);

  return (
    <div className="d-flex flex-column gap-20">
      <Text text="delivery_preparation_settings" type={TEXT.SECTION_HEADER} />
      <div className="d-flex flex-column gap-25">
        <PreparationOrderSettingsRadios title="delivery_units" options={timeUnitOptions} field="deliveryUnit" />
        <PreparationOrderSettingsInput title="txt_delivery_time" field="deliveryTime" />
        <PreparationOrderSettingsInput title="delivery_preparation_time" field="deliveryPreparationTime" />
      </div>
    </div>
  );
};
